/*
 * Copyright (c) 2024. Haodong JU
 */

import hillo from 'hillo'
import { reservationHost } from '@/model/dataLayer/service/reservation/reservation'
import { getCurrentDeviceId } from '@/model/dataLayer/service/RestaurantInfoService'

const url = reservationHost + 'settings/personRule/'

export async function savePersonRule (item) {
  return (await hillo.jsonPost(url + 'save', {
    ...item,
    userId: await getCurrentDeviceId()
  }))
}

export async function deletePersonRule (id) {
  return (await hillo.post(`${url}${id}/delete`, {}))
}

export async function getPersonRules () {
  return (await hillo.get(url + await getCurrentDeviceId(), {})).data
}
